module.exports.createAccordians = () => {
  let nodeAcc = Array.prototype.slice.call(document.getElementsByClassName("child-header"));
  nodeAcc.forEach(childHeader => {
    childHeader.classList.remove("active");
    if (!childHeader.classList.contains("hasListener")) {
      childHeader.addEventListener("click", function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        childHeader.classList.toggle("active");
        console.log("click accordion");
        /* Toggle between hiding and showing the active panel */
        var panel = childHeader.nextElementSibling;
        if (panel.classList.contains("close")) {
          panel.classList.remove("close");
        } else {
          panel.classList.add("close");
        }
      });
    }
    childHeader.classList.add("hasListener")
  });
};


// WEBPACK FOOTER //
// ./scripts/components/node-accordion.js